import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbComponent } from '@src/app/shared/components/breadcrumb/breadcrumb.component';
import { DataTablesModule } from 'angular-datatables';
import { QRCodeComponent } from 'angularx-qrcode';
import { NgOtpInputModule } from 'ng-otp-input';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { QuillModule } from 'ngx-quill';
import { IfRolesDirective } from '../core/directives/ifRoles.directive';
import { IfUserTypesDirective } from '../core/directives/ifUserTypes.directive';
import { MaterialModule } from '../material.module';
import { ChangePasswordDialogComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/change-password/change-password-dialog.component';
import { ForceChangePasswordDialogComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/force-change-password/force-change-password-dialog.component';
import { ForgotUsernameDialogComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/forgot-username/forgot-username-dialog.component';
import { MfaChallengeComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/mfa/mfa-challenge/mfa-challenge.component';
import { MFAComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/mfa/mfa-dialog/mfa-dialog.component';
import { MfaSetupComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/mfa/mfa-setup/mfa-setup.component';
import { ResetPasswordDialogComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/reset-password/reset-password-dialog.component';
import { ResetTempPasswordDialogComponent } from '../mepco-public/header-tabs/home/components/logIn/dialog/reset-temp-password/reset-temp-password-dialog.component';
import { PaymentService } from '../mepco-webview/account/views/make-payment/services/payment.service';
import { AddressFormComponent } from './components/address/address.component';
import { ConfirmDialogComponent } from './components/dialog/confirm-dialog.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { DisplayPdfComponent } from './components/display-pdf/display-pdf.component';
import { DateFilterComponent } from './components/filter/date-filter.component';
import { HubComponent } from './components/hub/hub.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MessageCardComponent } from './components/message-card/message-card.component';
import { PasswordStrengthComponent } from './components/password-strength/password-strength';
import { ResponseViewerComponent } from './components/response-viewer/response-viewer.component';
import { FilterComponent } from './components/table/filter.component';
import { TableComponent } from './components/table/table.component';
import { TextEditorComponent } from './components/text-editor/text-editor.component';
import { FooterComponent } from './footer/footer.component';
import { MepcoDatePipe } from './pipes/mepco-date-pipe';
import { SharedRoutingModule } from './shared-routing.module';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    ChangePasswordDialogComponent,
    ForceChangePasswordDialogComponent,
    ResetPasswordDialogComponent,
    ResetTempPasswordDialogComponent,
    ForgotUsernameDialogComponent,
    MfaSetupComponent,
    MfaChallengeComponent,
    MFAComponent,
    FooterComponent,
    HubComponent,
    TableComponent,
    FilterComponent,
    DialogComponent,
    IfRolesDirective,
    IfUserTypesDirective,
    DateFilterComponent,
    TextEditorComponent,
    ConfirmDialogComponent,
    DisplayPdfComponent,
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    MaterialModule,
    QuillModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ResponseViewerComponent,
    LoadingComponent,
    PdfJsViewerModule,
    QRCodeComponent,
    AddressFormComponent,
    MessageCardComponent,
    PasswordStrengthComponent,
    NgOtpInputModule,
    MepcoDatePipe,
  ],
  exports: [
    FooterComponent,
    BreadcrumbComponent,
    ChangePasswordDialogComponent,
    ForceChangePasswordDialogComponent,
    ResetPasswordDialogComponent,
    ResetTempPasswordDialogComponent,
    ForgotUsernameDialogComponent,
    MfaSetupComponent,
    MfaChallengeComponent,
    MFAComponent,
    FormsModule,
    ReactiveFormsModule,
    TableComponent,
    MaterialModule,
    HubComponent,
    FilterComponent,
    DialogComponent,
    IfRolesDirective,
    IfUserTypesDirective,
    DateFilterComponent,
    TextEditorComponent,
    ConfirmDialogComponent,
    DisplayPdfComponent,
    AddressFormComponent,
    MessageCardComponent,
    MepcoDatePipe,
  ],
  providers: [PaymentService, provideNgxMask()],
})
export class SharedModule {}
